module.exports = __webpack_public_path__ + "img/10.b4d59127.jpg";